<input type="text" [name]="currentQuestion.GUID" [(ngModel)]="currentValue" (keyup)="updateCurrentAnswer()" class="text-box mt-4" />